import { DateTime } from 'luxon';

const EventWebinarFormattedTime = ({
  isoDate,
  timeZone,
  fullMonth = false,
  isMonthFirst = false
}) => {
  const date = DateTime.fromISO(isoDate, { setZone: true, zone: timeZone });
  const { year, day } = date;
  const month = fullMonth
    ? date.toFormat('MMMM').toUpperCase()
    : date.toFormat('MMM').toUpperCase();
  return (
    <>
      {isMonthFirst ? (
        <>
          <span>{month}</span>
          <span className="event-day">{day}</span>,<span>{year}</span>
        </>
      ) : (
        <>
          <span className="event-day">{day}</span>
          <span>{month}</span>
          <span>{year}</span>
        </>
      )}
    </>
  );
};

export default EventWebinarFormattedTime;
